import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MailingService } from 'src/app/shared/services/mailing.service';

@Component({
  selector: 'molla-unsubscribe',
  templateUrl: './unsubscribe.component.html',
  styleUrls: ['./unsubscribe.component.scss']
})
export class UnsubscribeComponent implements OnInit {

  email: string = '';
  motivoSelezionato: string = '';
  source: string = 'myliteled.com';
  stato: 'form' | 'ok' | 'errore' = 'form';
  loading: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private mailingService: MailingService
  ) {}

  ngOnInit(): void {
    this.email = this.route.snapshot.queryParamMap.get('email') ?? '';
    this.source = this.route.snapshot.queryParamMap.get('source') ?? 'myliteled.com';
  }

  async conferma() {
    if (!this.email) { this.stato = 'errore'; return; }
    this.loading = true;
    try {
      var ret = await this.mailingService.unsubscribe(this.email, this.motivoSelezionato, this.source);
      this.stato = ret && ret.code == 0 ? 'ok' : 'errore';
    } catch {
      this.stato = 'errore';
    } finally {
      this.loading = false;
    }
  }
}